import ComingSoon from "components/ComingSoon";
import React from "react";

const Cloudinary = () => {
  return <ComingSoon />;
};

export default Cloudinary;
